// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Installation-module__wrapper___HkP4_ {
  display: flex;
  width: 1238px;
  padding: 100px 60px;
  flex-direction: column;
  align-items: center;
  gap: 45px;
  border-radius: 42px;
  background: #EEE;
  background: var(--element-bg, #EEE);
}

.Installation-module__title___SDR0h {
  display: flex;
  gap: 10px;
}

.Installation-module__head___daGBN {
  color: #0E0E0E;
  color: var(--black, #0E0E0E);
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
}

.Installation-module__topic___p5YXb {
  color: #41C4C4;
  color: var(--primary, #41C4C4);
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
}

.Installation-module__container___PCxVf {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 60px;
  align-self: stretch;
}

.Installation-module__wrap___WL9_D {
  display: flex;
  align-items: flex-start;
  gap: 72px;
  align-self: stretch;
}

.Installation-module__block___wvESN {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
}

.Installation-module__card___MzYx0 {
  display: flex;
  padding: 51px 85px 50px 80px;
  align-items: center;
  gap: 44px;
  align-self: stretch;
  border-radius: 20px;
  background: #FFF;
  background: var(--surface, #FFF);
}

.Installation-module__code___pDZiW {
  width: 164px;
  height: 164px;
}

.Installation-module__imgs___oECz5 {
  cursor: pointer;
  width: 118px;
}

.Installation-module__rede___JUkBU {
  display: flex;
  gap: 16px;
  align-items: center;
}

.Installation-module__img___lurJA {
  width: 88px;
  height: 88px;
}

.Installation-module__case___X58H4 {
  display: grid;
  grid-gap: 16px;
  gap: 16px;
}

.Installation-module__textBig___NyvC6 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.5px;
}

.Installation-module__text___ru9ZM {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
}

.Installation-module__cardTwo___F7Zks {
  display: flex;
  padding: 25px 137px 43px 136px;
  border-radius: 20px;
  background: #FFF;
}

.Installation-module__dialog___OFJcn {
  display: flex;
  padding: 19.231px 0px;
  flex-direction: column;
  align-items: center;
  gap: 12.821px;
  border-radius: 10.417px;
  box-shadow: 0px 2px 8px 0px rgba(0, 13, 38, 0.10);
}

.Installation-module__slip___qjDGa {
  display: flex;
  padding: 0px 19.231px;
  flex-direction: column;
  gap: 12px;
}

.Installation-module__wordBig___o3tOY {
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
}

.Installation-module__word___Y5s1Z {
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 16.026px;
  letter-spacing: 0.2px;
}

.Installation-module__actions___tPL8r {
  display: flex;
  padding: 6.41px 19.231px 0px 6.41px;
  justify-content: flex-end;
  align-items: center;
  gap: 6.41px;
  align-self: stretch;
}

.Installation-module__tactic___l5HL1 {
  font-family: Inter;
  font-size: 11.218px;
  font-weight: 600;
  line-height: 16.026px;
  letter-spacing: 0.08px;
}

.Installation-module__ticket___xmu80 {
  display: flex;
  padding: 59px 136px 62px 137px;
  border-radius: 20px;
  background: #FFF;
  background: var(--surface, #FFF);
}

.Installation-module__last___VrOKu {
  display: flex;
  width: 250px;
  padding: 19.231px 0px;
  flex-direction: column;
  align-items: center;
  gap: 13px;
  border-radius: 10.417px;
  box-shadow: 0px 2px 8px 0px rgba(0, 13, 38, 0.10);
}

.Installation-module__frame___FR9Kz {
  display: flex;
  align-items: center;
  gap: 13px;
}

.Installation-module__logo___re5ft {
  width: 27px;
  height: 27px;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .Installation-module__wrapper___HkP4_ {
    display: flex;
    width: 691px;
    padding: 80px 30px;
  }

  .Installation-module__head___daGBN {
    text-align: center;
    font-size: 25px;
  }

  .Installation-module__topic___p5YXb {
    font-size: 25px;
  }

  .Installation-module__container___PCxVf {
    gap: 40px;
  }

  .Installation-module__wrap___WL9_D {
    gap: 40px;
  }

  .Installation-module__card___MzYx0 {
    padding: 58px 17px 58px 28px;
    gap: 19.5px;
  }

  .Installation-module__code___pDZiW {
    width: 104px;
    height: 104px;
  }

  .Installation-module__imgs___oECz5 {
    width: 99px;
  }

  .Installation-module__rede___JUkBU {
    align-items: flex-start;
  }

  .Installation-module__img___lurJA {
    width: 61px;
    height: 61px;
  }

  .Installation-module__textBig___NyvC6 {
    font-size: 14px;
    line-height: normal;
  }

  .Installation-module__text___ru9ZM {
    font-size: 14px;
  }

  .Installation-module__cardTwo___F7Zks {
    padding: 24px 48px 24.91px 48.5px;
  }

  .Installation-module__dialog___OFJcn {
    padding: 15.308px 0px;
    gap: 10.205px;
  }

  .Installation-module__slip___qjDGa {
    padding: 0px 15.308px;
    gap: 10.205px;
  }

  .Installation-module__wordBig___o3tOY {
    font-size: 11.481px;
  }

  .Installation-module__word___Y5s1Z {
    font-size: 8.929px;
    line-height: 12.756px;
  }

  .Installation-module__actions___tPL8r {
    padding: 5.103px 15.308px 0px 5.103px;
    gap: 5.103px;
  }

  .Installation-module__tactic___l5HL1 {
    font-size: 8.929px;
  }

  .Installation-module__ticket___xmu80 {
    padding: 52px 48px 51.623px 48.5px;
  }

  .Installation-module__last___VrOKu {
    width: 199px;
    padding: 15.308px 0px;
    gap: 10.205px;
  }

  .Installation-module__frame___FR9Kz {
    display: flex;
    align-items: center;
    gap: 13px;
  }

  .Installation-module__logo___re5ft {
    width: 21px;
    height: 21px;
  }
}

@media (min-width: 360px) and (max-width: 767px) {
  .Installation-module__wrapper___HkP4_ {
    width: 312px;
    padding: 30px 18px;
    gap: 25px;
  }

  .Installation-module__title___SDR0h {
    display: flex;
    gap: 2px;
    flex-direction: column;
    align-items: center;
  }

  .Installation-module__head___daGBN {
    text-align: center;
    font-size: 25px;
  }

  .Installation-module__topic___p5YXb {
    font-size: 25px;
  }

  .Installation-module__container___PCxVf {
    gap: 40px;
  }

  .Installation-module__wrap___WL9_D {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    align-self: stretch;
  }

  .Installation-module__card___MzYx0 {
    padding: 23px 63px;
    flex-direction: column;
    gap: 17px;
  }

  .Installation-module__code___pDZiW {
    width: 104px;
    height: 104px;
  }

  .Installation-module__rede___JUkBU {
    align-items: flex-start;
  }

  .Installation-module__img___lurJA {
    width: 61px;
    height: 61px;
  }

  .Installation-module__textBig___NyvC6 {
    font-size: 14px;
    line-height: normal;
  }

  .Installation-module__text___ru9ZM {
    font-size: 14px;
  }

  .Installation-module__cardTwo___F7Zks {
    padding: 24px 48px 24.91px 48.5px;
  }

  .Installation-module__dialog___OFJcn {
    padding: 15.308px 0px;
    gap: 10.205px;
  }

  .Installation-module__slip___qjDGa {
    padding: 0px 15.308px;
    gap: 10.205px;
  }

  .Installation-module__wordBig___o3tOY {
    font-size: 11.481px;
  }

  .Installation-module__word___Y5s1Z {
    font-size: 8.929px;
    line-height: 12.756px;
  }

  .Installation-module__actions___tPL8r {
    padding: 5.103px 15.308px 0px 5.103px;
    gap: 5.103px;
  }

  .Installation-module__tactic___l5HL1 {
    font-size: 8.929px;
  }

  .Installation-module__ticket___xmu80 {
    padding: 52px 29px 51.623px 48px;
  }

  .Installation-module__last___VrOKu {
    width: 199px;
    padding: 15.308px 0px;
    gap: 10.205px;
  }

  .Installation-module__frame___FR9Kz {
    gap: 10.348px;
  }

  .Installation-module__logo___re5ft {
    width: 21px;
    height: 21px;
  }
}`, "",{"version":3,"sources":["webpack://./src/widgets/installation/ui/Installation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAA4B;EAA5B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  width: 1238px;\n  padding: 100px 60px;\n  flex-direction: column;\n  align-items: center;\n  gap: 45px;\n  border-radius: 42px;\n  background: var(--element-bg, #EEE);\n}\n\n.title {\n  display: flex;\n  gap: 10px;\n}\n\n.head {\n  color: var(--black, #0E0E0E);\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.topic {\n  color: var(--primary, #41C4C4);\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 60px;\n  align-self: stretch;\n}\n\n.wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 72px;\n  align-self: stretch;\n}\n\n.block {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 32px;\n  flex: 1 0 0;\n}\n\n.card {\n  display: flex;\n  padding: 51px 85px 50px 80px;\n  align-items: center;\n  gap: 44px;\n  align-self: stretch;\n  border-radius: 20px;\n  background: var(--surface, #FFF);\n}\n\n.code {\n  width: 164px;\n  height: 164px;\n}\n\n.imgs {\n  cursor: pointer;\n  width: 118px;\n}\n\n.rede {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.img {\n  width: 88px;\n  height: 88px;\n}\n\n.case {\n  display: grid;\n  gap: 16px;\n}\n\n.textBig {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n}\n\n.text {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.cardTwo {\n  display: flex;\n  padding: 25px 137px 43px 136px;\n  border-radius: 20px;\n  background: #FFF;\n}\n\n.dialog {\n  display: flex;\n  padding: 19.231px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 12.821px;\n  border-radius: 10.417px;\n  box-shadow: 0px 2px 8px 0px rgba(0, 13, 38, 0.10);\n}\n\n.slip {\n  display: flex;\n  padding: 0px 19.231px;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wordBig {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.word {\n  font-family: Inter;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16.026px;\n  letter-spacing: 0.2px;\n}\n\n.actions {\n  display: flex;\n  padding: 6.41px 19.231px 0px 6.41px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 6.41px;\n  align-self: stretch;\n}\n\n.tactic {\n  font-family: Inter;\n  font-size: 11.218px;\n  font-weight: 600;\n  line-height: 16.026px;\n  letter-spacing: 0.08px;\n}\n\n.ticket {\n  display: flex;\n  padding: 59px 136px 62px 137px;\n  border-radius: 20px;\n  background: var(--surface, #FFF);\n}\n\n.last {\n  display: flex;\n  width: 250px;\n  padding: 19.231px 0px;\n  flex-direction: column;\n  align-items: center;\n  gap: 13px;\n  border-radius: 10.417px;\n  box-shadow: 0px 2px 8px 0px rgba(0, 13, 38, 0.10);\n}\n\n.frame {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.logo {\n  width: 27px;\n  height: 27px;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .wrapper {\n    display: flex;\n    width: 691px;\n    padding: 80px 30px;\n  }\n\n  .head {\n    text-align: center;\n    font-size: 25px;\n  }\n\n  .topic {\n    font-size: 25px;\n  }\n\n  .container {\n    gap: 40px;\n  }\n\n  .wrap {\n    gap: 40px;\n  }\n\n  .card {\n    padding: 58px 17px 58px 28px;\n    gap: 19.5px;\n  }\n\n  .code {\n    width: 104px;\n    height: 104px;\n  }\n\n  .imgs {\n    width: 99px;\n  }\n\n  .rede {\n    align-items: flex-start;\n  }\n\n  .img {\n    width: 61px;\n    height: 61px;\n  }\n\n  .textBig {\n    font-size: 14px;\n    line-height: normal;\n  }\n\n  .text {\n    font-size: 14px;\n  }\n\n  .cardTwo {\n    padding: 24px 48px 24.91px 48.5px;\n  }\n\n  .dialog {\n    padding: 15.308px 0px;\n    gap: 10.205px;\n  }\n\n  .slip {\n    padding: 0px 15.308px;\n    gap: 10.205px;\n  }\n\n  .wordBig {\n    font-size: 11.481px;\n  }\n\n  .word {\n    font-size: 8.929px;\n    line-height: 12.756px;\n  }\n\n  .actions {\n    padding: 5.103px 15.308px 0px 5.103px;\n    gap: 5.103px;\n  }\n\n  .tactic {\n    font-size: 8.929px;\n  }\n\n  .ticket {\n    padding: 52px 48px 51.623px 48.5px;\n  }\n\n  .last {\n    width: 199px;\n    padding: 15.308px 0px;\n    gap: 10.205px;\n  }\n\n  .frame {\n    display: flex;\n    align-items: center;\n    gap: 13px;\n  }\n\n  .logo {\n    width: 21px;\n    height: 21px;\n  }\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n  .wrapper {\n    width: 312px;\n    padding: 30px 18px;\n    gap: 25px;\n  }\n\n  .title {\n    display: flex;\n    gap: 2px;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .head {\n    text-align: center;\n    font-size: 25px;\n  }\n\n  .topic {\n    font-size: 25px;\n  }\n\n  .container {\n    gap: 40px;\n  }\n\n  .wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 32px;\n    align-self: stretch;\n  }\n\n  .card {\n    padding: 23px 63px;\n    flex-direction: column;\n    gap: 17px;\n  }\n\n  .code {\n    width: 104px;\n    height: 104px;\n  }\n\n  .rede {\n    align-items: flex-start;\n  }\n\n  .img {\n    width: 61px;\n    height: 61px;\n  }\n\n  .textBig {\n    font-size: 14px;\n    line-height: normal;\n  }\n\n  .text {\n    font-size: 14px;\n  }\n\n  .cardTwo {\n    padding: 24px 48px 24.91px 48.5px;\n  }\n\n  .dialog {\n    padding: 15.308px 0px;\n    gap: 10.205px;\n  }\n\n  .slip {\n    padding: 0px 15.308px;\n    gap: 10.205px;\n  }\n\n  .wordBig {\n    font-size: 11.481px;\n  }\n\n  .word {\n    font-size: 8.929px;\n    line-height: 12.756px;\n  }\n\n  .actions {\n    padding: 5.103px 15.308px 0px 5.103px;\n    gap: 5.103px;\n  }\n\n  .tactic {\n    font-size: 8.929px;\n  }\n\n  .ticket {\n    padding: 52px 29px 51.623px 48px;\n  }\n\n  .last {\n    width: 199px;\n    padding: 15.308px 0px;\n    gap: 10.205px;\n  }\n\n  .frame {\n    gap: 10.348px;\n  }\n\n  .logo {\n    width: 21px;\n    height: 21px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Installation-module__wrapper___HkP4_`,
	"title": `Installation-module__title___SDR0h`,
	"head": `Installation-module__head___daGBN`,
	"topic": `Installation-module__topic___p5YXb`,
	"container": `Installation-module__container___PCxVf`,
	"wrap": `Installation-module__wrap___WL9_D`,
	"block": `Installation-module__block___wvESN`,
	"card": `Installation-module__card___MzYx0`,
	"code": `Installation-module__code___pDZiW`,
	"imgs": `Installation-module__imgs___oECz5`,
	"rede": `Installation-module__rede___JUkBU`,
	"img": `Installation-module__img___lurJA`,
	"case": `Installation-module__case___X58H4`,
	"textBig": `Installation-module__textBig___NyvC6`,
	"text": `Installation-module__text___ru9ZM`,
	"cardTwo": `Installation-module__cardTwo___F7Zks`,
	"dialog": `Installation-module__dialog___OFJcn`,
	"slip": `Installation-module__slip___qjDGa`,
	"wordBig": `Installation-module__wordBig___o3tOY`,
	"word": `Installation-module__word___Y5s1Z`,
	"actions": `Installation-module__actions___tPL8r`,
	"tactic": `Installation-module__tactic___l5HL1`,
	"ticket": `Installation-module__ticket___xmu80`,
	"last": `Installation-module__last___VrOKu`,
	"frame": `Installation-module__frame___FR9Kz`,
	"logo": `Installation-module__logo___re5ft`
};
export default ___CSS_LOADER_EXPORT___;
